<template>
  <div>
    <video :src="video" class="morseanim-video" ref="video" @ended="onVideoEnd"
           @timeupdate="onVideoProgress" @pause="onVideoProgress" @canplay="onVideoProgress"></video>
    <PlayerControls :playing="playing" :progress="progress" @toggle="togglePlay" @reset="resetPlay" />
  </div>
</template>

<script>
import PlayerControls from "@/components/layout/PlayerControls";

export default {
  components: {PlayerControls},
  props: {
    video: String
  },
  data: () => ({
    playing: false,
    progress: 0
  }),
  mounted() {

  },
  watch: {
    video() {
      this.playing = false
    }
  },
  methods: {
    togglePlay() {
      this.playing = !this.playing
      if(this.playing) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
    },
    resetPlay() {
      this.playing = true
      this.$refs.video.currentTime = 0
      this.$refs.video.play()
    },
    onVideoEnd() {
      this.playing = false
    },
    onVideoProgress() {
      this.progress = this.$refs.video.currentTime / this.$refs.video.duration
    }
  }
}
</script>

<style scoped lang="scss">
.morseanim {
  &-video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: calc(100% - 50px);
  }
}
</style>